import { translate } from "./index";

/**
 * Shows a loading spinner on the save button, disables it, and extracts the
 * signed GID and attribute name from its data attributes.
 * @param {Event} event - The click event from the save button.
 * @returns {{ signedGid: string, attribute: string }}
 */
export function prepareSaveButton(event) {
  const button = event.currentTarget;
  const saving = translate("shared.saving");
  button.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> ${saving}`;
  button.classList.add("disabled");
  return {
    signedGid: button.getAttribute("data-signed-gid"),
    attribute: button.getAttribute("data-attribute"),
  };
}

/**
 * Disable a button and return a callback to re enable them
 * @param button
 * @param text
 * @returns {(function(): void)|*}
 */
export function disableButton(button, text) {
  const html = button.innerHTML;
  button.classList.add("disabled");
  button.disabled = true;
  button.innerHTML = text;
  return () => {
    button.classList.remove("disabled");
    button.disabled = false;
    button.innerHTML = html;
  };
}
